import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ["input", "error"];
    static values = { errorTemplate: String };
    
    connect() {
        // Don't validate on connect - only on blur
    }
    
    validate() {
        const value = this.inputTarget.value.trim();
        
        if (value === '') {
            this.clearError();
            return;
        }
        
        // Split by comma and validate each email
        const emails = value.split(',').map(email => email.trim()).filter(email => email !== '');
        const invalidEmails = [];
        
        // Simple email regex pattern
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        emails.forEach(email => {
            if (!emailPattern.test(email)) {
                invalidEmails.push(email);
            }
        });
        
        if (invalidEmails.length > 0) {
            // Use the error template from data attribute, or fall back to default
            const errorTemplate = this.hasErrorTemplateValue 
                ? this.errorTemplateValue 
                : 'Ongeldige e-mailadres(sen): __EMAILS__';
            const errorMessage = errorTemplate.replace('__EMAILS__', invalidEmails.join(', '));
            this.showError(errorMessage);
        } else {
            this.clearError();
        }
    }
    
    showError(message) {
        // Look for existing error element
        let errorDiv = this.inputTarget.parentNode.querySelector('.invalid-feedback');
        
        if (!errorDiv) {
            // Create error element if it doesn't exist
            errorDiv = document.createElement('div');
            errorDiv.className = 'invalid-feedback';
            this.inputTarget.parentNode.appendChild(errorDiv);
        }
        
        errorDiv.textContent = message;
        errorDiv.style.display = 'block';
        this.inputTarget.classList.add('is-invalid');
    }
    
    clearError() {
        // Look for existing error element
        const errorDiv = this.inputTarget.parentNode.querySelector('.invalid-feedback');
        if (errorDiv) {
            // Remove the element entirely instead of hiding it
            errorDiv.remove();
        }
        this.inputTarget.classList.remove('is-invalid');
    }
    
    preventSubmitIfInvalid(event) {
        this.validate();
        
        if (this.inputTarget.classList.contains('is-invalid')) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}